import { render } from "./GoogleIcon.vue?vue&type=template&id=171dde9b&ts=true"
import script from "./GoogleIcon.vue?vue&type=script&lang=ts"
export * from "./GoogleIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__